export const siteMeta = {
  name: "避雷档案",
  slogan: "国产消费避坑情报站",
  intro:
    "我们把分散在各处的消费体验，整理成一份份可查可比的避雷档案。所有条目均为用户投稿整理，品牌名为化名示例，仅作买前参考，不构成任何事实认定。",
  email: "hello@bileidangan.com",
  submitEmail: "tips@bileidangan.com",
  updateNote: "每日 09:00 更新昨日新增速报",
};

export const navItems = [
  { id: "top", label: "首页" },
  { id: "radar", label: "本周雷达" },
  { id: "topics", label: "主题分类" },
  { id: "archive", label: "避雷档案" },
  { id: "guide", label: "踩坑指南" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于我们" },
  { id: "contact", label: "投稿爆料" },
];

export const stats = [
  { id: 1, label: "已收录争议品牌", value: "1280", suffix: "家", icon: "ri-archive-2-line" },
  { id: 2, label: "汇总避雷记录", value: "4630", suffix: "条", icon: "ri-file-warning-line" },
  { id: 3, label: "昨日新增速报", value: "36", suffix: "条", icon: "ri-flashlight-line" },
  { id: 4, label: "用户投稿采纳率", value: "92", suffix: "%", icon: "ri-user-follow-line" },
];

export const heroBackground =
  "https://readdy.ai/api/search-image?query=abstract%20dark%20crimson%20and%20amber%20paper%20collage%20texture%20with%20distressed%20newsprint%20layers%20and%20redaction%20marks%2C%20moody%20editorial%20archival%20atmosphere%2C%20dramatic%20high%20contrast%20lighting%2C%20no%20text%2C%20abstract%20background&width=1600&height=1000&seq=bldossier-hero-1&orientation=landscape";

export const tickerItems = [
  "澜图清洁电器：保修期与宣传页不一致，本周新增 42 条记录",
  "沐风厨卫：安装另收费争议持续，累计 517 条",
  "听澜音频：参数虚标投稿集中，退货门槛被质疑",
  "禾味记食品：配料表表述争议，建议核对实物标签",
  "云栖童装：尺码偏小与缩水问题重复出现",
  "南屿家居：效果图与实际材质落差是主要争议点",
];

export const categories = [
  {
    key: "quality",
    label: "产品质量问题",
    icon: "ri-shield-cross-line",
    desc: "做工粗糙、易损易坏、材质与描述存在落差等实物层面的争议。",
    count: 1682,
    hint: "最集中的是耐用性与用料",
  },
  {
    key: "service",
    label: "售后纠纷",
    icon: "ri-customer-service-2-line",
    desc: "保修缩水、维修排队久、换货门槛高、客服响应慢等服务流程问题。",
    count: 1145,
    hint: "留意保修条款的细则",
  },
  {
    key: "marketing",
    label: "虚假宣传",
    icon: "ri-megaphone-line",
    desc: "参数虚标、功效夸大、效果图与实物不符等宣传描述层面的争议。",
    count: 986,
    hint: "以实物标签为准",
  },
  {
    key: "trap",
    label: "营销套路",
    icon: "ri-price-tag-3-line",
    desc: "先涨后降、赠品不兑现、限时话术、套装捆绑等促销环节的争议。",
    count: 817,
    hint: "下单前比价与留存截图",
  },
];

export const latestReports = [
  {
    id: 1,
    title: "澜图清洁电器：核心部件保修年限与详情页不一致",
    excerpt:
      "多位用户投稿称，购买页面标注的整机保修年限，与到货后包装内说明存在差异，涉及核心电机部件的维修费用需自行承担。",
    category: "service",
    categoryLabel: "售后纠纷",
    brandName: "澜图清洁电器",
    date: "2026-09-11",
    riskLevel: "高",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20a%20sleek%20handheld%20vacuum%20cleaner%20silhouette%20on%20textured%20kraft%20paper%2C%20warm%20amber%20and%20deep%20crimson%20palette%2C%20moody%20editorial%20lighting%2C%20minimal%20composition%2C%20no%20text&width=800&height=560&seq=bld-report-01&orientation=landscape",
  },
  {
    id: 2,
    title: "沐风厨卫：安装费另计，套餐价格与到手价差距明显",
    excerpt:
      "用户反馈促销页面展示的套装价未包含上门安装，实际结算时被追加多项费用，客服对收费口径的解释前后不一致。",
    category: "trap",
    categoryLabel: "营销套路",
    brandName: "沐风厨卫",
    date: "2026-09-10",
    riskLevel: "高",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20chrome%20kitchen%20faucet%20and%20ceramic%20tiles%20on%20textured%20paper%2C%20warm%20amber%20and%20crimson%20palette%2C%20moody%20editorial%20lighting%2C%20no%20text&width=800&height=560&seq=bld-report-02&orientation=landscape",
  },
  {
    id: 3,
    title: "听澜音频：参数标注与实际听感存在争议",
    excerpt:
      "投稿集中反映续航与频响参数标注偏乐观，用户实测结果与宣传页数据差距较大，部分订单退货申请被反复要求补充凭证。",
    category: "marketing",
    categoryLabel: "虚假宣传",
    brandName: "听澜音频",
    date: "2026-09-09",
    riskLevel: "高",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20wireless%20earbuds%20charging%20case%20on%20textured%20paper%2C%20warm%20amber%20and%20crimson%20palette%2C%20moody%20editorial%20product%20photography%2C%20no%20text&width=800&height=560&seq=bld-report-03&orientation=landscape",
  },
  {
    id: 4,
    title: "禾味记食品：配料表表述差异引消费者核对",
    excerpt:
      "用户比对包装实物与商品详情后发现配料排序与描述用词不一致，建议下单前以实物标签为准，注意查看临期条款。",
    category: "quality",
    categoryLabel: "产品质量问题",
    brandName: "禾味记食品",
    date: "2026-09-08",
    riskLevel: "中",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20packaged%20snack%20boxes%20on%20textured%20paper%2C%20warm%20amber%20and%20crimson%20palette%2C%20moody%20editorial%20lighting%2C%20no%20text&width=800&height=560&seq=bld-report-04&orientation=landscape",
  },
  {
    id: 5,
    title: "迅野运动装备：尺码偏差与面料气味被反复提及",
    excerpt:
      "尺码偏小半码到一码、深色款洗涤后轻微褪色、新鞋气味较大是本周投稿中出现频率最高的三个问题。",
    category: "quality",
    categoryLabel: "产品质量问题",
    brandName: "迅野运动装备",
    date: "2026-09-07",
    riskLevel: "中",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20folded%20running%20shoes%20on%20textured%20paper%2C%20warm%20amber%20and%20crimson%20palette%2C%20moody%20editorial%20lighting%2C%20no%20text&width=800&height=560&seq=bld-report-05&orientation=landscape",
  },
  {
    id: 6,
    title: "初见美妆：赠品规格缩水，宣传话术待核实",
    excerpt:
      "满赠活动的赠品规格与宣传图不一致，部分用户收到的赠品为试用装，客服以页面细则为由不予补发。",
    category: "trap",
    categoryLabel: "营销套路",
    brandName: "初见美妆",
    date: "2026-09-06",
    riskLevel: "中",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20still%20life%20of%20cosmetic%20cream%20jar%20and%20dropper%20on%20textured%20paper%2C%20warm%20amber%20and%20crimson%20palette%2C%20moody%20editorial%20lighting%2C%20no%20text&width=800&height=560&seq=bld-report-06&orientation=landscape",
  },
];

export const brandReports = [
  {
    id: 1,
    slug: "lantu-cleaning",
    brandName: "澜图清洁电器",
    industry: "小家电",
    category: "service",
    categoryLabel: "售后纠纷",
    riskLevel: "高",
    reportCount: 486,
    riskTags: ["保修缩水", "配件收费", "客服失联"],
    summary: "核心部件保修期与宣传页不一致，保外维修报价透明度不足，是本季度售后类投稿最集中的条目之一。",
    detail: [
      "宣传页以显著位置标注整机长保修，但包装内说明对核心电机部件的保修期限另作约定。",
      "保外维修报价需先寄回检测，检测费与配件费分项结算，部分用户反映事前无法获知大致区间。",
      "高峰期客服在线通道排队时间偏长，个别投稿称在线工单超过三天未获实质回复。",
    ],
    advice: "下单前保存页面保修说明截图；收货后第一时间核对包装内保修卡条款，必要时通过官方渠道书面确认。",
    updatedAt: "2026-09-11",
  },
  {
    id: 2,
    slug: "mufeng-kitchen",
    brandName: "沐风厨卫",
    industry: "家装厨卫",
    category: "quality",
    categoryLabel: "产品质量问题",
    riskLevel: "高",
    reportCount: 517,
    riskTags: ["生锈漏水", "安装另收费", "客服口径不一"],
    summary: "厨卫五金件在潮湿环境下出现锈蚀与渗漏反馈较多，叠加安装费用争议，形成质量与套路双重投诉。",
    detail: [
      "投稿反馈厨房龙头与角阀使用数月后出现锈点，密封圈渗水的情况集中在同批次产品。",
      "套餐价未包含上门安装，结算环节追加的多项费用引发大量争议。",
      "同一问题在不同客服处的答复口径存在差异，用户难以获得统一处理方案。",
    ],
    advice: "优先选择支持官方上门安装并明示费用的渠道；留存到货开箱视频，便于后续举证。",
    updatedAt: "2026-09-10",
  },
  {
    id: 3,
    slug: "tinglan-audio",
    brandName: "听澜音频",
    industry: "3C 数码",
    category: "marketing",
    categoryLabel: "虚假宣传",
    riskLevel: "高",
    reportCount: 341,
    riskTags: ["参数虚标", "音质争议", "退货门槛高"],
    summary: "续航与频响参数标注偏乐观，实测结果与宣传数据差距明显，退货流程被指门槛偏高。",
    detail: [
      "标称续航时长在开启降噪后明显缩短，与宣传页给出的测试条件未充分说明。",
      "频响曲线图与用户实测听感存在出入，相关描述用词引发争议。",
      "退货申请被要求补充开箱视频、外包装完整性等多重凭证，流程体验较差。",
    ],
    advice: "以第三方实测数据与真实听感评价为主要参考；保留完整包装，便于在退换期内操作。",
    updatedAt: "2026-09-09",
  },
  {
    id: 4,
    slug: "heweiji-food",
    brandName: "禾味记食品",
    industry: "食品饮料",
    category: "quality",
    categoryLabel: "产品质量问题",
    riskLevel: "中",
    reportCount: 312,
    riskTags: ["配料表争议", "临期不退", "口感不符"],
    summary: "配料排序与描述用词存在差异，临期商品的退换政策也成为争议焦点。",
    detail: [
      "商品详情的配料表述与实物标签的排序用词不完全一致，用户建议以实物为准。",
      "临期批次在下单页面未显著提示，引发部分用户对时效的误判。",
      "口感与宣传描述存在预期落差，属于主观感受差异较大的一类反馈。",
    ],
    advice: "下单前确认生产日期与保质期展示方式，接收后核对实物标签，按要求储存。",
    updatedAt: "2026-09-08",
  },
  {
    id: 5,
    slug: "xunye-sports",
    brandName: "迅野运动装备",
    industry: "户外运动",
    category: "quality",
    categoryLabel: "产品质量问题",
    riskLevel: "中",
    reportCount: 274,
    riskTags: ["尺码偏小", "洗涤褪色", "新鞋气味大"],
    summary: "尺码偏差与面料问题在运动鞋服类目中较为集中，深色款首次洗涤需留意。",
    detail: [
      "多款鞋型建议比日常码数大半码至一码，商品页尺码表参考意义有限。",
      "深色运动服首次单独洗涤时出现轻微浮色，建议与浅色衣物分开清洗。",
      "新鞋开箱气味较大，通风晾置数日后有所缓解。",
    ],
    advice: "优先选择支持七天无理由且提供运费险的店铺；深色款首次洗涤单独进行。",
    updatedAt: "2026-09-07",
  },
  {
    id: 6,
    slug: "chujian-beauty",
    brandName: "初见美妆",
    industry: "美妆个护",
    category: "marketing",
    categoryLabel: "虚假宣传",
    riskLevel: "中",
    reportCount: 265,
    riskTags: ["成分夸大", "赠品缩水", "活动细则"],
    summary: "满赠活动赠品规格与宣传图不符，成分相关表述的严谨性也受到用户质疑。",
    detail: [
      "满赠宣传图展示的赠品为正装规格，实际到货多为试用装。",
      "成分功效表述使用较为绝对的用词，与护肤品常见的审慎表述方式不符。",
      "活动细则以小字置于页面底部，用户下单前容易忽略。",
    ],
    advice: "下单前展开活动细则并截图留档；对功效描述保持理性预期。",
    updatedAt: "2026-09-06",
  },
  {
    id: 7,
    slug: "nanyu-home",
    brandName: "南屿家居",
    industry: "家居日用",
    category: "marketing",
    categoryLabel: "虚假宣传",
    riskLevel: "高",
    reportCount: 398,
    riskTags: ["材质不符", "效果图误导", "色差明显"],
    summary: "效果图与实物在材质、色彩上的落差是投稿中最集中的争议点，退款沟通成本偏高。",
    detail: [
      "渲染效果图的光影与质感明显优于实拍，用户收到实物后产生较大预期落差。",
      "部分商品描述中的材质用词较为笼统，收货后发现与理解不符。",
      "大件商品的退货运费分摊问题，导致用户退款积极性下降。",
    ],
    advice: "重点查看买家实拍与差评区；大件商品下单前确认退换运费由谁承担。",
    updatedAt: "2026-09-05",
  },
  {
    id: 8,
    slug: "qingcheng-digital",
    brandName: "青橙数码配件",
    industry: "3C 配件",
    category: "service",
    categoryLabel: "售后纠纷",
    riskLevel: "中",
    reportCount: 221,
    riskTags: ["售后推诿", "运费自付", "换新门槛"],
    summary: "配件类商品的质保执行存在推诿现象，来回运费承担问题引发较多不满。",
    detail: [
      "质保期内的换新申请被要求多次补充购买凭证与问题视频。",
      "非质量问题以外的检测往返运费需用户先行垫付，流程繁琐。",
      "客服将问题转交多个渠道，用户需反复描述同一情况。",
    ],
    advice: "保留订单信息与聊天记录；优先在平台内发起售后，便于平台介入。",
    updatedAt: "2026-09-04",
  },
  {
    id: 9,
    slug: "yunqi-kids",
    brandName: "云栖童装",
    industry: "母婴童装",
    category: "quality",
    categoryLabel: "产品质量问题",
    riskLevel: "中",
    reportCount: 189,
    riskTags: ["缩水变形", "线头较多", "尺码偏小"],
    summary: "童装的缩水与做工细节问题重复出现，尺码偏小导致退货率偏高。",
    detail: [
      "多次洗涤后衣长与袖长出现缩水，面料回弹表现一般。",
      "走线与线头处理不够细致，个别批次存在开线情况。",
      "尺码较标准偏小，家长普遍建议按实际身高上浮一码选择。",
    ],
    advice: "下单前参考评论区实测尺寸；新衣先用冷水轻柔手洗一次，观察缩水情况。",
    updatedAt: "2026-09-03",
  },
  {
    id: 10,
    slug: "shiguang-luggage",
    brandName: "拾光旅行箱",
    industry: "箱包出行",
    category: "quality",
    categoryLabel: "产品质量问题",
    riskLevel: "低",
    reportCount: 143,
    riskTags: ["轮子异响", "拉杆松动", "壳面划痕"],
    summary: "旅行箱整体口碑尚可，争议集中在轮组与拉杆的耐久表现上。",
    detail: [
      "使用一段时间后万向轮出现异响，机场地面推行体验下降。",
      "拉杆在满载状态下有轻微晃动，属于该价位常见现象。",
      "深色光面外壳较易显现划痕，建议搭配箱套使用。",
    ],
    advice: "优先选择轮组可更换的款式；托运前加装箱套，减少外观磨损。",
    updatedAt: "2026-09-02",
  },
  {
    id: 11,
    slug: "maitian-appliance",
    brandName: "麦田小厨电",
    industry: "小家电",
    category: "service",
    categoryLabel: "售后纠纷",
    riskLevel: "中",
    reportCount: 233,
    riskTags: ["维修排队", "换新门槛", "检测费用"],
    summary: "小厨电的维修网点覆盖不足，寄修周期偏长是主要争议来源。",
    detail: [
      "部分地区无授权维修点，需寄回厂商检测，往返周期偏长。",
      "换新需满足多项条件，包括外观完整度与配件齐全度。",
      "检测后判定为非质量问题时，需自行承担检测与物流费用。",
    ],
    advice: "购买前确认本地是否有维修网点；保留包装与配件，降低换新门槛。",
    updatedAt: "2026-09-01",
  },
  {
    id: 12,
    slug: "mojian-stationery",
    brandName: "墨见文具",
    industry: "办公文具",
    category: "marketing",
    categoryLabel: "虚假宣传",
    riskLevel: "低",
    reportCount: 96,
    riskTags: ["赠品不兑现", "描述含糊", "发货延迟"],
    summary: "文具类目争议程度较轻，主要集中在赠品兑现与描述细节上。",
    detail: [
      "页面标注的赠品在结算时未自动加入，需主动联系客服补发。",
      "部分商品的规格描述较为笼统，容易产生理解偏差。",
      "促销期订单量集中，发货时效较日常明显延长。",
    ],
    advice: "结算前核对赠品是否已加入购物车；促销期预留更长的收货时间。",
    updatedAt: "2026-08-31",
  },
];

export const guideImage =
  "https://readdy.ai/api/search-image?query=abstract%20desk%20flat%20lay%20with%20notebook%2C%20magnifier%20and%20checklist%20cards%20on%20textured%20paper%2C%20warm%20amber%20and%20crimson%20palette%2C%20moody%20editorial%20lighting%2C%20no%20text&width=900&height=700&seq=bld-guide-01&orientation=squarish";

export const aboutImage =
  "https://readdy.ai/api/search-image?query=abstract%20composition%20of%20stacked%20archive%20folders%20and%20index%20cards%20on%20textured%20paper%2C%20warm%20amber%20and%20crimson%20palette%2C%20moody%20editorial%20lighting%2C%20no%20text&width=900&height=700&seq=bld-about-01&orientation=squarish";

export const guideItems = [
  {
    id: 1,
    title: "下单之前",
    desc: "把宣传与实物可能存在的落差，提前用截图固定下来。",
    icon: "ri-shopping-bag-3-line",
    points: ["保存商品页宣传文案与参数截图", "对照评论区实拍与差评关键词", "确认退换货规则与运费承担方"],
  },
  {
    id: 2,
    title: "收货当时",
    desc: "开箱环节是最容易被忽略、也最关键的取证窗口。",
    icon: "ri-open-arm-line",
    points: ["保留带面单的外包装完整", "录制一镜到底的开箱视频", "核对实物标签与页面描述是否一致"],
  },
  {
    id: 3,
    title: "使用期间",
    desc: "把问题发生的时间点与现象记录下来，避免口头描述。",
    icon: "ri-tools-line",
    points: ["记录故障出现的具体时间与场景", "拍照或录像留存现象证据", "保存与客服的完整沟通记录"],
  },
  {
    id: 4,
    title: "售后维权",
    desc: "优先在平台内沟通，让流程与凭证可被追溯。",
    icon: "ri-shield-check-line",
    points: ["先走平台售后，再考虑其他渠道", "清晰说明诉求与依据的条款", "必要时向消费者权益保护渠道反映"],
  },
];

export const faqs = [
  {
    id: 1,
    question: "避雷档案里的品牌条目是真实的吗？",
    answer:
      "站内所有品牌名均为化名示例，内容由用户投稿整理并归纳表述，用于说明常见的消费争议类型，不指向任何特定真实企业，也不构成对任何主体的事实认定或评价。",
  },
  {
    id: 2,
    question: "遇到疑似虚假宣传，我应该保留哪些证据？",
    answer:
      "建议保存商品详情页宣传文案与参数的截图、下单与支付记录、客服沟通记录以及开箱视频。宣传承诺与实际不符时，这些材料能在售后沟通中提供清晰依据。",
  },
  {
    id: 3,
    question: "页面标注的价格与到手价为什么会有差距？",
    answer:
      "常见原因是套餐价未包含安装费、运费或配件费用，也可能叠加了限时活动的细则条件。下单前请展开活动细则，逐项确认最终结算金额包含哪些内容。",
  },
  {
    id: 4,
    question: "怎么判断一条避雷信息是否值得参考？",
    answer:
      "先看问题是否可复现、是否有具体场景描述，再看同类反馈是否集中出现。单条情绪化描述参考价值有限，多来源、可验证的重复问题更值得重视。",
  },
  {
    id: 5,
    question: "如何向避雷档案投稿自己的消费经历？",
    answer:
      "可以在本页底部的投稿表单中填写品牌类别、问题类型与经过描述。我们会核实描述是否具体、可复现，再整理成档案条目，个人信息不会公开展示。",
  },
  {
    id: 6,
    question: "站内内容会定期更新吗？",
    answer:
      "会。速报在每个工作日上午 09:00 更新，档案条目的记录数与更新时间也会随投稿变化同步调整，你可以收藏本页以便随时查看。",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "林先生",
    role: "家装采购用户",
    content:
      "装修买五金前先翻了这里的售后条目，把保修条款提前问清楚，后面省了不少扯皮的时间。",
  },
  {
    id: 2,
    name: "周女士",
    role: "母婴用品用户",
    content:
      "尺码偏小这类问题在档案里写得很具体，按建议上浮一码选，退换的麻烦确实少了很多。",
  },
  {
    id: 3,
    name: "陈同学",
    role: "数码爱好者",
    content:
      "参数看宣传、听感看实测，这个思路就是从这里学到的。买前多花十分钟，能避开不少套路。",
  },
];